import { resolveMemberMediaUrl } from '@formosa/shared/utils/mediaUrl';

export const TRAVEL_CHAT_IMAGE_MAX_BYTES = 5 * 1024 * 1024;
export const TRAVEL_CHAT_IMAGE_ALLOWED_EXT = Object.freeze(['.jpg', '.jpeg', '.png', '.gif']);
export const TRAVEL_CHAT_IMAGE_ALLOWED_MIME = Object.freeze([
  'image/jpeg',
  'image/jpg',
  'image/png',
  'image/gif',
]);

export function validateTravelChatImageFile(file) {
  if (!file || file.size <= 0) {
    return { ok: false, error: '請選擇圖片。' };
  }
  if (file.size > TRAVEL_CHAT_IMAGE_MAX_BYTES) {
    return { ok: false, error: '圖片超過 5MB 上限。' };
  }
  const name = String(file.name || '').toLowerCase();
  const ext = name.includes('.') ? name.slice(name.lastIndexOf('.')) : '';
  if (!TRAVEL_CHAT_IMAGE_ALLOWED_EXT.includes(ext)) {
    return { ok: false, error: '僅支援 JPG、PNG、GIF。' };
  }
  const mime = String(file.type || '').toLowerCase().split(';')[0].trim();
  if (mime && !TRAVEL_CHAT_IMAGE_ALLOWED_MIME.includes(mime)) {
    return { ok: false, error: '僅支援 JPG、PNG、GIF。' };
  }
  return { ok: true };
}

export function resolveChatImageSrc(message) {
  const objectKey = message?.objectKey == null ? '' : String(message.objectKey).trim();
  const mediaUrl = message?.mediaUrl == null ? '' : String(message.mediaUrl).trim();
  const raw = objectKey || mediaUrl;
  if (!raw) return '';
  if (/^(javascript|data|vbscript):/i.test(raw) || raw.includes('..') || raw.includes('\\')) {
    return '';
  }
  const resolved = resolveMemberMediaUrl(raw);
  if (!resolved || /^(javascript|data|vbscript):/i.test(resolved)) {
    return '';
  }
  return resolved;
}

export function chatImageAlt(message) {
  return String(message?.fileName || message?.text || '圖片');
}
